import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import HostedCardDetails from './partials/HostedCardDetails';
import { CONNECT_FINANCIAL_CARD_DETAILS_PAGE } from './queries';
import { GenericLoading } from '../../components/Placeholders';

const CardConnectFinancialDetailsView = () => {
  const { t: translate } = useTranslation();
  const [pageFailed, setPageFailed] = useState(false);

  const { data, error, isFetching, refetch } = useQuery(CONNECT_FINANCIAL_CARD_DETAILS_PAGE);
  const handlePageFailed = useCallback(() => setPageFailed(true), []);
  const pageUrl = data?.hostedPageUrl;
  const isSecurePageUrl = typeof pageUrl === 'string' && pageUrl.startsWith('https://');

  const retry = () => {
    setPageFailed(false);
    refetch();
  };

  const renderBody = () => {
    if (isFetching) {
      return <GenericLoading customSize="4rem" customSpacing="my-5" isFullScreen={false} />;
    }

    if (error || pageFailed || !isSecurePageUrl) {
      return (
        <div className="py-4">
          <div className="alert alert-danger" role="alert">
            <i className="icon icon-info-icon" />
            <span className="content mx-md-4">
              {translate('card_connect_financial_details_error')}
            </span>
          </div>
          <button type="button" className="btn btn-primary w-100" onClick={retry}>
            {translate('try_again_btn_title')}
          </button>
        </div>
      );
    }

    return <HostedCardDetails key={pageUrl} url={pageUrl} onFailed={handlePageFailed} />;
  };

  return (
    <ModalBodyLayout
      withBack={false}
      isIframe
      renderHeader={() => (
        <div className="flex-row-center w-100">
          <b className="text-f5 text-dark">{translate('card_connect_financial_details_title')}</b>
        </div>
      )}>
      {renderBody()}
    </ModalBodyLayout>
  );
};

export default CardConnectFinancialDetailsView;
